import { useState } from "@wordpress/element";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";
import { Outlet } from "react-router-dom";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import settings from "settings";

const Root = styled("div")(({ theme }) => ({
	"& .Login3-leftSection": {},

	"& .Login3-rightSection": {},
}));

const { urls } = settings;

function LoginPage() {
	const [isLogin, setIsLogin] = useState(true);
	function handleNavigate() {
		window.location.href = urls.checkout;
	}

	return (
		<Root className="flex flex-col flex-auto items-center justify-center shrink-0">
			<motion.div
				initial={{ opacity: 0, scale: 0.6 }}
				animate={{ opacity: 1, scale: 1 }}
				className="flex flex-col w-full md:max-w-3xl overflow-hidden"
			>
				<Outlet />

				<Divider className="my-10" />
				<div className="Login3-rightSection flex flex-1 items-center justify-center mt-32">
					<motion.div
						initial={{ opacity: 0, y: 40 }}
						animate={{ opacity: 1, y: 0, transition: { delay: 0.2 } }}
					>
						<Button
							variant="contained"
							color="primary"
							className="w-192 mb-8"
							onClick={handleNavigate}
						>
							Continue as Guest
						</Button>
					</motion.div>
				</div>
			</motion.div>
		</Root>
	);
}

export default LoginPage;
